import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store.vuex';
import { vxm } from '@/store.vuex';
import { i18n } from '@/plugins/i18n';
import VModal from 'vue-js-modal';
import VueCookies from 'vue-cookies';
import BootstrapVue from 'bootstrap-vue';
import VueYouTubeEmbed from 'vue-youtube-embed';
import { BSpinner } from 'bootstrap-vue';
import VueMoment from 'vue-moment';
import { BrandingInfo } from './models/branding/branding';
import { ClientConfigs } from './models/configs/ClientConfigs';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import Help from './components/Help.vue';
import axios from 'axios';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
//import material-icon scss
import 'font-awesome/css/font-awesome.min.css';
import FormFieldUtilPlugin from './plugins/formFieldUtilsPlugin';
import WLToastr from './plugins/wlToastr';
import vueVimeoPlayer from 'vue-vimeo-player';
import infiniteScroll from 'vue-infinite-scroll';
import ReadMore from 'vue-read-more';
import 'vue-search-select/dist/VueSearchSelect.css';
import linkify from 'vue-linkify';
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';
import { DEFAULT_WL_ALLOWED_TAGS } from './defaultWLAllowedTags';
import vClickOutside from 'v-click-outside';
Vue.use(vClickOutside);

import VueSanitize from 'vue-sanitize';
Vue.use(VueSanitize, {
  allowedTags: VueSanitize.defaults.allowedTags.concat([
    'img',
    'svg',
    'style',
    'i',
    'button',
    'span',
    'label',
    'ul',
    'li',
    'input',
  ]),
  allowedAttributes: DEFAULT_WL_ALLOWED_TAGS,
  allowedSchemes: ['data', 'https'],
});

declare var window: any;
//defined as global component
Vue.component(
  'VueFontawesome',
  require('vue-fontawesome-icon/VueFontawesome.vue').default,
);

Vue.component('b-spinner', BSpinner);
Vue.use(BootstrapVue);
Vue.config.productionTip = false;
Vue.use(VModal, {
  dynamic: true,
  injectModalsContainer: true,
});
Vue.use(VueCookies);
Vue.use(VueYouTubeEmbed);
Vue.use(MultiSelectPlugin);
Vue.component('help', Help);
Vue.use(VueMoment);
Vue.use(VueLodash, { lodash: lodash });
Vue.use(FormFieldUtilPlugin);
Vue.use(vueVimeoPlayer);
Vue.use(infiniteScroll);
Vue.use(ReadMore);
Vue.use(Tooltip);
Vue.directive('linkified', linkify);
Vue.use(WLToastr);

const app = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
});

// Default Settings for all clients
const DEFAULT_SETTINGS = { 
  IS_GDPR_ENABLED: true,
  REFERRAL_ENABLED: true,
  QUICK_JOB_APPLY_ENABLED: true,
  OPEN_TIMESHEET_IN_NEW_TAB: false,
  DISABLE_APPLINK_IN_BANNER: false,
  SIGNUP_ADDITIONAL_CONSENT: '',
  JOB_REDIRECTION_PROMPT:''
};

// Get current language
let jwt =(Vue.cookies && Vue.cookies.get('jwtToken')) || window.WorkLLama.jwt;
let languagePreferenceData = 'en';
const params = new URLSearchParams(window.location.search);
const locale = params.get("locale"); 

if(vxm.jobs.BrandingInfo.ENABLE_DYNAMIC_HEADER_INJECTION){
  // let headerLanguage = document.querySelector('#localeSelector');
//  languagePreferenceData= headerLanguage?.value;
}
if(locale){
 languagePreferenceData =locale;
   vxm.users.setUserLang(locale);
}
if(jwt){
  vxm.users.fetchLanguagePreference()
.then(lang => {languagePreferenceData = lang});
}
const lang = app.$cookies && app.$cookies.get('userLang') || 'en';
languagePreferenceData = languagePreferenceData === 'en' ? lang : languagePreferenceData;
const localizedMessagesAPI = axios.get(`/atsuser/localized-messages/${languagePreferenceData}`)
  .catch((err) => { return err; });
if (jwt) {
vxm.users.setToken(jwt);
vxm.users.setAuthStatus(true);
}

if (window.WorkLLama.isConfigJSONEnabled === 'true') {
  try {
    let newAPI;
  if (vxm.users.isLoggedIn) {
    const token = 'Bearer ' + vxm.users.getToken;
    newAPI = axios.get(
      `/configservice/api/v1/configs/${window.WorkLLama.companyCode}`,
      {
        headers: {
          'Content-Type': 'application/json',
           Authorization: token 
        },
      },
    );
  }
  else{
    newAPI = axios.get(
      `/configservice/api/v1/configs/anon//${window.WorkLLama.companyCode}`,
      {
        headers: {
          'Content-Type': 'application/json'
        },
      },
    );
  }

    Promise.all([newAPI, localizedMessagesAPI]).then(async ([newResponse, localizedMessages]) => {
      // added for testing, not in use
      const configs = { ...DEFAULT_SETTINGS, ...newResponse.data };
      app.$store.commit('configs/setClientConfigs', configs);
      app.$store.commit('utility/setAppTheme', 'server-theme');
      app.$route.name !== 'AppSignup' &&
        app.$store.dispatch('utility/initLatLong');
      const getCurrentUserEmail = function() {
        const isLoggedIn = app.$store.getters['users/isLoggedIn'];
        const myUserProfile = app.$store.getters['users/myUserProfile'];
        return isLoggedIn && myUserProfile ? myUserProfile.email : '';
      };
      let chatbotWidgetUrl
      try {
        const chatbotUrls = JSON.parse(window.WorkLLama.chatbotWidgetUrl)
        const url = chatbotUrls.urls[lang || 'en']
        window.WorkLLama.chatbotWidgetUrl = url
        chatbotWidgetUrl = url + '?' + 'widget=true';
      } catch (e) {
        chatbotWidgetUrl = window.WorkLLama.chatbotWidgetUrl + '?' + 'widget=true';
      }
      window.WorkLLama.chatbotWidgetIconUrl = `/atsuser/data/logo/${
        newResponse.data.companyCode
      }/CANDIDATEPORTAL/chat_bubble.svg`;
      window.WorkLLama.chatbotWidgetIconHoverUrl = `/atsuser/data/logo/${
        newResponse.data.companyCode
      }/CANDIDATEPORTAL/chat_hover_bubble.svg`;
      if (app.$store.getters['configs/GlobalConfig']['ENABLE_CHATBOT'] && window.$('body').chatbotPanel) {
        // Create chatbot panel and store instance
        window.chatbotPanelInstance = window.$('body').chatbotPanel({
          openDuration: 500,
          closeDuration: 300,
          //chatbotUrl: 'https://contextual-sofi-d2.workingllama.com/',
          chatbotUrl: chatbotWidgetUrl,
          chatButtonClass: 'fas fa-robot',
          userEmail: getCurrentUserEmail(),
        });
        // Watch LoggedIn status to update / remove user email
        app.$store.watch(
          () => {
            return app.$store.getters['users/isLoggedIn'];
          },
          () => {
            // Update current user email in chatbot url
            if (window.chatbotPanelInstance)
              window.chatbotPanelInstance.updateUserEmail(
                getCurrentUserEmail(),
              );
          },
        );
      }

      // Validate and set translation values
      if (localizedMessages && localizedMessages.data) {
        i18n.mergeLocaleMessage("en", localizedMessages.data);
      }

      app.$mount('#app');
    });
  } catch (e) {
    console.log('Error getting Client Config: ', e);
  }

  // End New Settings
} else {
  const newAPI =
    axios
    .get('/atsuser/api/v1/company', {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    Promise.all([newAPI, localizedMessagesAPI])
    .then(async ([response , localizedMessages]) => {
      let bInfo = new BrandingInfo();
      bInfo = response.data;
      const brand = bInfo.companycode
        .replace(/DEV|QA|UAT|D2|DEMO2$/i, '')
        .toLowerCase();
      let appTheme = '';
      try {
        const configs = await import('./assets/' + brand + '/config.json');
        bInfo = { ...DEFAULT_SETTINGS, ...configs.default, ...bInfo };
        appTheme = `${brand}-theme`;
      } catch (e) {
        const configs = await import('./assets/wltmplt/config.json');
        bInfo = { ...DEFAULT_SETTINGS, ...configs.default, ...bInfo };
        appTheme = 'wltmplt-theme';
      }
    
      app.$store.commit('utility/setAppTheme', appTheme);
      app.$store.commit('jobs/setBrandingInfo', bInfo);
      app.$store.commit('jobs/setCompanyCode', bInfo.companycode);
      app.$store.commit(
        'jobs/setBrandingLogo',
        bInfo.CANDIDATE_PORTAL_LOGO_URL,
      );
      // app.$store.dispatch('jobs/getJobFilters', bInfo.companycode);
      // app.$store.dispatch('jobs/loadJobs');
      // app.$store.dispatch('jobs/getCustomFilters', bInfo.companycode);
      app.$store.dispatch('jobs/setDropboxAppKey', bInfo.DROPBOX_APP_KEY);
      app.$store.commit(
        'utility/setCandidatePortalTitle',
        bInfo.WL_CANDIDATE_PORTAL_TITLE,
      );
      app.$store.commit(
        'utility/setCandidatePortalApplicationName',
        bInfo.WL_CANDIDATE_PORTAL_APPLICATION_NAME,
      );
      app.$route.name !== 'AppSignup' &&
        app.$store.dispatch('utility/initLatLong');
      document.title = bInfo.WL_CANDIDATE_PORTAL_TITLE;

      // Validate and get logged user email
      const getCurrentUserEmail = function() {
        const isLoggedIn = app.$store.getters['users/isLoggedIn'];
        const myUserProfile = app.$store.getters['users/myUserProfile'];
        return isLoggedIn && myUserProfile ? myUserProfile.email : '';
      };

      let chatbotWidgetUrl
      try {
        const chatbotUrls = JSON.parse(window.WorkLLama.chatbotWidgetUrl)
        const url = chatbotUrls.urls[lang || 'en']
        window.WorkLLama.chatbotWidgetUrl = url
        chatbotWidgetUrl = url + '?' + 'widget=true';
      } catch (e) {
        chatbotWidgetUrl = window.WorkLLama.chatbotWidgetUrl + '?' + 'widget=true';
      }
      window.WorkLLama.chatbotWidgetIconUrl = `/atsuser/data/logo/${
        bInfo.companycode
      }/CANDIDATEPORTAL/chat_bubble.svg`;
      window.WorkLLama.chatbotWidgetIconHoverUrl = `/atsuser/data/logo/${
        bInfo.companycode
      }/CANDIDATEPORTAL/chat_hover_bubble.svg`;
      if (bInfo.ENABLE_CHATBOT && window.$('body').chatbotPanel) {
        // Create chatbot panel and store instance
        window.chatbotPanelInstance = window.$('body').chatbotPanel({
          openDuration: 500,
          closeDuration: 300,
          //chatbotUrl: 'https://contextual-sofi-d2.workingllama.com/',
          chatbotUrl: chatbotWidgetUrl,
          chatButtonClass: 'fas fa-robot',
          userEmail: getCurrentUserEmail(),
        });
        // Watch LoggedIn status to update / remove user email
        app.$store.watch(
          () => {
            return app.$store.getters['users/isLoggedIn'];
          },
          () => {
            // Update current user email in chatbot url
            if (window.chatbotPanelInstance)
              window.chatbotPanelInstance.updateUserEmail(
                getCurrentUserEmail(),
              );
          },
        );
      }
      if (bInfo.AUDIO_EYE_SITE_HASH) {
        function a() {
          var b = function() {
            window.__AudioEyeSiteHash = bInfo.AUDIO_EYE_SITE_HASH;
            var a = document.createElement('script');
            a.src = 'https://wsmcdn.audioeye.com/aem.js';
            a.type = 'text/javascript';
            a.setAttribute('async', '');
            document.getElementsByTagName('body')[0].appendChild(a);
          };
          'complete' !== document.readyState
            ? window.addEventListener
              ? window.addEventListener('load', b)
              : window.attachEvent && window.attachEvent('onload', b)
            : b();
        }
        a();
      }

      // Validate and set translation values
      if (localizedMessages && localizedMessages.data) 
        i18n.mergeLocaleMessage("en", localizedMessages.data);{
      }
      if (bInfo.DISPLAY_HEADER_FROM_CMS) {
        await app.$store.dispatch('utility/getHeader');
      }
    })
    .catch((error) => {
      // handle error
      console.log('catch:', error);
    })
    .finally(() => {
      // always executed
      app.$mount('#app');
      console.log('finally');
    });
}
